import { z } from "zod";
import { apiListSchema } from "./list";

//? DTO
const CreateTourDayDtoSchema = z.object({
  TourId: z.number(),
  Day: z.number().nullish(),
  Name: z.string().nullish(),
});
export type CreateTourDayDto = z.infer<typeof CreateTourDayDtoSchema>;

export const TourDayDtoSchema = CreateTourDayDtoSchema.extend({
  Id: z.number(),
});
export type TourDayDto = z.infer<typeof TourDayDtoSchema>;

export const tourDayDtoListSchema = apiListSchema(TourDayDtoSchema);
//? Model

export const CreateTourDaySchema = z.object({
  tourId: z.number(),
  day: z.number(),
  name: z.string().nullish(),
});

export const TourDaySchema = CreateTourDaySchema.extend({
  id: z.string().min(1),
});

export type CreateTourDay = z.infer<typeof CreateTourDaySchema>;

export type TourDay = z.infer<typeof TourDaySchema>;

//? Mappers

export function tourDayFromDto(dto: TourDayDto): TourDay {
  return {
    id: dto.Id.toString(),
    day: dto.Day ?? -1,
    name: dto.Name,
    tourId: dto.TourId,
  };
}

export function tourDayToDto(dto: TourDay): TourDayDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createTourDayToDto(dto),
  };
}

export function createTourDayToDto(dto: CreateTourDay): CreateTourDayDto {
  return {
    Day: dto.day,
    Name: dto.name,
    TourId: dto.tourId,
  };
}
